import React, { useState } from "react";
import { Modal, Button } from "antd";
import AddVacancyForm from "../Vacancy/AddVacancyForm";

const AddVacancyModal = ({ onVacancyAdded }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleSuccess = (newVacancy) => {
    if (onVacancyAdded) onVacancyAdded(newVacancy);
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        color={"cyan"}
        variant="outlined"
        onClick={showModal}
      >
        + Աշխատանքի Տեղ
      </Button>
      <Modal
        title="Add New Vacancy"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        destroyOnHidden
      >
        <AddVacancyForm
          onSuccess={handleSuccess}
          action="Add Vacancy"
        />
      </Modal>
    </>
  );
};

export default AddVacancyModal;
